const attention = {
  open: 'Open alerts',
  close: 'Close alerts',
  title: 'Alerts',
  intro: 'New leads, human requests and response deadlines that need your attention.',
  unreadCount: '{count} unread',
  markAll: 'Mark all read',
  filter: { all: 'All', unread: 'Unread', lead: 'New leads', human: 'Human requests' },
  kind: {
    lead_created: 'New qualified lead received',
    human_handoff_requested: 'Buyer requested human help',
    sla_warning: 'First response due soon',
    sla_overdue: 'Response deadline missed',
  },
  body: {
    lead_created: 'The buyer provided an authorised contact channel. Continue in the matching lead.',
    human_handoff_requested: 'Open the exact Airlock conversation or its matching lead.',
    sla_warning: 'This lead still needs the next required human action.',
    sla_overdue: 'The frozen response deadline has passed without the required action.',
  },
  target: { lead: 'Lead detail', conversation: 'Reception conversation' },
  openTarget: 'Open and handle',
  markRead: 'Mark read',
  read: 'Read',
  unread: 'Unread',
  urgent: 'Urgent',
  emptyTitle: 'Nothing needs your attention',
  emptyBody: 'New business events will appear here without changing their workflow status.',
  loading: 'Checking for new alerts…',
  failed: 'Alerts could not be loaded.',
  retry: 'Try again',
  newToast: '{count} new alert(s)',
  boundary: 'Read status belongs only to this inbox. Assignment, follow-up and outcomes remain in the lead workflow.',
  emailBoundary: 'Email follows workspace settings; an email failure never removes the in-app alert.',
  justNow: 'Just now',
  minutesAgo: '{count} min ago',
  hoursAgo: '{count} hr ago',
  daysAgo: '{count} d ago',
} as const

export default attention
